import ProtectImg from './common/protect_img.es6';
import OsUtils from './common/utils/os.es6';

import Canvas from './top/canvas/main.es6';
import SubMv from './top/sub_mv.es6';
import MainMv from './top/main_mv.es6';
import Parallax from './top/parallax.es6';
import Slider from './top/slider.es6';
import Scroll from './top/scroll.es6';
import Modal from './top/modal.es6';
import Acc from './top/acc.es6';
import Tab from './top/tab.es6';

class Main {
    constructor() {
        this.protectImg = new ProtectImg();
        this.canvas = new Canvas();
        this.subMv = new SubMv(this);
        this.mainMv = new MainMv(this);
        this.parallax = new Parallax();
        this.slider = new Slider();
        this.scroll = new Scroll();
        this.modal = new Modal(this);
        this.acc = new Acc();
        this.tab = new Tab(this);

        this._setMobileClass();
        this._init();
    }

    _setMobileClass() {
        OsUtils.getMobileOS && document.body.classList.add('-mobile');
    }

    _init() {
        window.addEventListener('load', () => {
            this.subMv.setAnimate();
            this.mainMv.setAnimate();
            this.parallax.updateParallax();
            this.acc.setHeight();
            this.acc.eventBind();
        });

        window.addEventListener('scroll', () => {
            this.scroll.setScrolling();
        });

        window.addEventListener('resize', () => {
            this.canvas.initIcons();
            this.acc.initHeight();
        });
    }
}

const main = new Main();
